import { atom } from "recoil";

import { TabEnum } from "@/pages/index-page/constants";
import { LearningRecordType } from "@/pages/index-page/props";
import {
  ICourseLearningRecord,
  ITutorialsLearningRecord,
} from "@/types/course-detail";
import { ICoursewareDatum, ITutorialType } from "@/types/index-page";

export const courseLearningRecordState = atom<ICourseLearningRecord | null>({
  key: "courseLearningRecord",
  default: null,
});

export const tutorialsLearningRecordState =
  atom<ITutorialsLearningRecord | null>({
    key: "tutorialsLearningRecord",
    default: null,
  });

export const homeCourseLearningRecordState = atom<LearningRecordType | null>({
  key: "homeCourseLearningRecord",
  default: null,
});

export const homeCoursewaersState = atom<ICoursewareDatum[] | []>({
  key: "homeCoursewaers",
  default: [],
});

export const homeTutorialLearningRecordState = atom<LearningRecordType | null>({
  key: "homeTutorialLearningRecord",
  default: null,
});

export const homeTutorialsState = atom<ITutorialType[] | []>({
  key: "homeTutorials",
  default: [],
});

export const homeActiveTabState = atom<number>({
  key: "homeActiveTab",
  default: 0, // 0: Course, 1: Tutorial
});

export const homeSearchIdState = atom<{ id: string; type: TabEnum } | null>({
  key: "homeSearchId",
  default: null, // 0: Course, 1: Tutorial
});
